"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ColorCell = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _constants = require("../../utils/constants");

require("./index.css");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var COLOR_COLUMN_COUNT = 6;
var ColorCell = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var color = _ref.color,
      checked = _ref.checked,
      onClick = _ref.onClick,
      children = _ref.children,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["color", "checked", "onClick", "children"]);
  return /*#__PURE__*/_react["default"].createElement("button", (0, _extends2["default"])({}, rest, {
    className: "color-picker-cell rounded-full cursor-pointer select-none m-1 hover:shadow-lg",
    style: _objectSpread({
      padding: 2
    }, checked ? {
      boxShadow: "0px 0px 1px 2px ".concat(color)
    } : {}),
    onClick: onClick,
    ref: ref
  }), (0, _isNil["default"])(children) ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-5 h-5 select-none rounded-full",
    style: {
      backgroundColor: color
    }
  }) : children);
});
exports.ColorCell = ColorCell;

var _default = function _default(_ref2) {
  var theme = _ref2.theme,
      className = _ref2.className,
      value = _ref2.value,
      onChange = _ref2.onChange,
      _ref2$colors = _ref2.colors,
      colors = _ref2$colors === void 0 ? _constants.COLORS : _ref2$colors,
      _ref2$columnCount = _ref2.columnCount,
      columnCount = _ref2$columnCount === void 0 ? COLOR_COLUMN_COUNT : _ref2$columnCount,
      _ref2$Cell = _ref2.Cell,
      Cell = _ref2$Cell === void 0 ? ColorCell : _ref2$Cell;
  var focusedRef = (0, _react.useRef)(false);

  var _useState = (0, _react.useState)(function () {
    if (!value) return 0;
    var index = colors.indexOf(value);
    return ~index ? index : 0;
  }),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      tabIndex = _useState2[0],
      setTabIndex = _useState2[1];

  var colorCellsRef = (0, _react.useRef)([]);
  (0, _react.useEffect)(function () {
    colorCellsRef.current[tabIndex] && colorCellsRef.current[tabIndex].focus();
  }, [tabIndex]);

  var handleKeyDown = function handleKeyDown(e) {
    if (!focusedRef.current) return;
    e.stopPropagation();

    switch (e.key) {
      case 'ArrowLeft':
        e.preventDefault();
        return setTabIndex(function (index) {
          return Math.max(index - 1, 0);
        });

      case 'ArrowRight':
        e.preventDefault();
        return setTabIndex(function (index) {
          return Math.min(index + 1, colors.length - 1);
        });

      case 'ArrowUp':
        e.preventDefault();
        return setTabIndex(function (index) {
          return index - columnCount < 0 ? index : index - columnCount;
        });

      case 'ArrowDown':
        e.preventDefault();
        return setTabIndex(function (index) {
          return index + columnCount > colors.length - 1 ? index : index + columnCount;
        });

      default:
        return;
    }
  };

  var handleFocus = function handleFocus() {
    focusedRef.current = true;
  };

  var handleBlur = function handleBlur() {
    focusedRef.current = false;
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('p-1 dark:bg-card', className),
    onKeyDown: handleKeyDown,
    onFocus: handleFocus,
    onBlur: handleBlur
  }, new Array(Math.ceil(colors.length / columnCount)).fill().map(function (_, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex",
      key: index
    }, colors.slice(index * columnCount, (index + 1) * columnCount).map(function (color, rowIndex) {
      var cellIndex = index * columnCount + rowIndex;
      return /*#__PURE__*/_react["default"].createElement(Cell, {
        theme: theme,
        key: color,
        color: color,
        checked: value === color,
        ref: function ref(item) {
          return colorCellsRef.current[cellIndex] = item;
        },
        onClick: function onClick() {
          return onChange(color);
        },
        tabIndex: tabIndex === cellIndex ? '0' : '-1'
      });
    }));
  }));
};

exports["default"] = _default;
//# sourceMappingURL=index.js.map